
import PassengerWithSms from '@/components/Passenger/models/PassengerWithSms';
import { Organization } from '@/models/Organization';
import RideitInvitation from '@/models/Rideit/RideitInvitation';
import RideitPassengerToken, { RideitPassengerTokenStatus } from '@/models/Rideit/RideitPassengerToken';
import { IDataTableHeader, IDataTablePagination } from '@/typings/dataTable';
import {Component, Prop, Vue} from 'vue-property-decorator';
import RideitInvitationTableItem from '@/components/Organization/Rideit/RideitInvitationTableItem.vue';
import { getInvitationStatus, getLatestInvitationPerPhoneNumber, IRideitInvitationTableItem, RideitInvitationWithSmsStatus } from '@/util/rideitHelper';
import RideitInvitationFormData from '@/models/Rideit/RideitInvitationFormData';

@Component({
  components: {
    RideitInvitationTableItem,
  }
})
export default class RideitInvitationTable extends Vue {

  @Prop({ default: () => []}) private value: IRideitInvitationTableItem[];
  @Prop({ required: true }) private pagination: IDataTablePagination;
  @Prop({ default: () => [] }) private invitations: RideitInvitation[];
  @Prop({ default: () => [] }) private tokens: RideitPassengerToken[];
  @Prop({ default: () => [] }) private passengers: PassengerWithSms[];
  @Prop({ default: '' }) private errorMessage: string;
  @Prop({ required: true}) private invitationForm: RideitInvitationFormData;

  organization: Organization = this.getOrganization();

  headers: IDataTableHeader[] = [
    { text: this.$t('passenger.prop.name.label'), value: 'name', sortable: true },
    { text: this.$t('passenger.prop.destinations.main'), value: 'destination', sortable: true },
    { text: this.$t('generic.tags'), value: 'tags', sortable: true },
    { text: this.$t('rideIt.invitations'), value: 'invitations',  sortable: true },
    { text: this.$t('rideIt.tokens.tokens'), value: 'tokens', sortable: true },
    { text: this.$t('passenger.prop.phoneNumbers.label'), value: 'phone', sortable: true },
    { text: this.$t('rideIt.tokens.newTokensAmount'),  value: 'newTokensAmount', sortable: true },
  ];

  get selected() {
    return this.value;
  }
  set selected(newValue: IRideitInvitationTableItem[]) {
    this.$emit('input', newValue);
  }

  get paginationSync() {
    return this.pagination;
  }
  
  set paginationSync(newPagination: IDataTablePagination) {
    this.$emit('update:pagination', newPagination);
  }

  get shownItems() {
    return this.passengers.map(p => {
      const passengerTokens = this.tokens.filter(t => t.passenger.movitId === p.id);
      const passengerInvitations = this.invitations.filter(i => i.passengers.some(ip => ip.movitId === p.id));
      
      const destinationId = p.passengerDestinations?.[0]?.destinationId;
      const destination = this.$store.state.destination.destinations.find((d: any) => d.id === destinationId);

      const item = {
        name: p.name,
        destination: destination?.alias ?? '',
        tags: p.groups ?? '',
        invitations: passengerInvitations,
        tokens: passengerTokens,
        phone: p.phoneNumbers?.map(pn => pn.number).join(', ') ?? '',
        newTokensAmount: 0,
        passenger: p,
        selected: false,
      } as IRideitInvitationTableItem;

      item.newTokensAmount = this.invitationForm.getInviteablePhoneNumbersFromItem(item).length;

      return item;
    });
  }

  getOrganization() {
    const organizationId = this.$route.params.organizationId;
    return this.$store.state.organization.organizations.find((o: Organization) => o.id === organizationId);
  }

  cancelToken(token: RideitPassengerToken) {
    this.$emit('cancel-token', token);
  }

}
